import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as HoverCopy } from "../../assets/images/icons/HoverCopy.svg";

import CM from "../../assets/images/profile.webp";
import { getInitials } from "../utilityFunctions/stringUtility";
import { pushAlert } from "../alertSlice";
import EmailICon from "../../assets/images/InActiveEmail.webp";
import CallICon from "../../assets/images/InActivecall.webp";
import AvatarName from "../../components/UniversalComponents/AvatarName";

const UserPopUpDetails = ({
  onHandleShowDetails,
  tableDetail,
  dataInputRow,
  Item,
  customerData,
  headerKey,
  disableShowMore,
}) => {
  const [isDetailsVisible, setDetailsVisible] = useState(false);
  const popupRef = useRef(null);
  const dispatch = useDispatch();

  const closePopup = () => {
    setDetailsVisible(false);
  };

  const toggleDetails = (event) => {
    event.stopPropagation();
    setDetailsVisible((prevState) => !prevState);
    onHandleShowDetails();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };

    if (isDetailsVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDetailsVisible]);

  const getRequiredData = () => {
    const { customer_id, user_name, email, mobile, reporting, manager_email, manager_phone } = customerData;
    if (headerKey === "user_name") {
      return { name: user_name?.value, email: email?.value, mobile: mobile?.value };
    } else if (headerKey === "reporting") {
      return { name: reporting?.value, email: manager_email?.value, mobile: manager_phone?.value };
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        dispatch(pushAlert({ message: "Copied", type: "success", visible: true }));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div className="py-2 min-w-[249px]">
      <div className="rounded-lg bg-white">
        <div className={`${!disableShowMore && "border-b-2"} space-y-2 pb-2`}>
          <div className="flex px-2 space-x-2 items-center">
            <div>
              <div className="   flex justify-center items-center ">
                <AvatarName
                  name={getInitials(getRequiredData()?.name, 1)}
                  size="medium"
                  bgColor={"#E8ECF299"}
                  textColor={"#7C7C83"}
                  borderColor={"#ABABAC"}
                />
              </div>
            </div>
            <div className="text-2999BC text-14">
              <label>{getRequiredData()?.name}</label>
            </div>
          </div>
          <div className="flex px-2 space-x-2 my-2 group items-center">
            <div className="w-5 text-center">
              {/* <i className="bi bi-envelope bi-xl"></i> */}
              <img src={EmailICon} alt="inactiveicon" className=" hover:bg-[#1D4469]" />
            </div>
            <div className="text-F16136 text-12">
              <label>{getRequiredData()?.email}</label>
            </div>
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(getRequiredData()?.email || "-");
              }}
              className="hidden ml-2 cursor-pointer group-hover:block"
            >
              {" "}
              <HoverCopy />
            </span>
          </div>
          <div className="flex px-2 space-x-2 my-2 group items-center">
            <div className="w-5 text-center">
              {/* <i className="bi bi-telephone bi-xl"></i> */}
              <img src={CallICon} alt="InActiveCall" className="hover:bg-[#1D4469] border-none"></img>
            </div>
            <div className={`${getRequiredData()?.mobile ? "text-F16136" : "text-light-grey"} text-12`}>
              <label>{getRequiredData()?.mobile ? getRequiredData()?.mobile : "Not Available"}</label>
            </div>
            {getRequiredData()?.mobile && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(getRequiredData()?.mobile || "-");
                }}
                className="hidden ml-2 cursor-pointer group-hover:block"
              >
                {" "}
                <HoverCopy />
              </span>
            )}
          </div>
        </div>
        {!disableShowMore && (
          <div className="flex justify-end mt-2 me-5 text-12">
            <button className="text-blue-500 inline-block" onClick={toggleDetails}>
              {isDetailsVisible ? "Show more" : "Show more"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserPopUpDetails;
